'use client';

import { use } from 'react';
import { notFound } from 'next/navigation';

import { GRID_TEMPLATE_COLUMNS, HomeContainer, HomeSkeleton } from '@/components';
import { useCategories } from '@/services/query/landing.queries';

interface CategoryPageProps {
  params: Promise<{ category: string }>;
}

export default function DynamicCategoryPage({ params }: CategoryPageProps) {
  const { category: categorySlug } = use(params);

  const { data, isLoading } = useCategories();

  if (isLoading) {
    // HomeContainer (rendered below once categories resolve) uses
    // HomeComponent's auto-fit markets grid — match it here so this
    // brief categories-loading skeleton doesn't jump to a different grid.
    return <HomeSkeleton gridTemplateColumns={GRID_TEMPLATE_COLUMNS} />;
  }

  const category = data?.find((cat) => cat.slug === categorySlug);

  if (!category) {
    notFound();
  }

  return <HomeContainer />;
}
